"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var chip = _7a468({
  defaultClassName: "ChoiceChips_chip__1vjfhh56",
  variantClassNames: {
    isSelected: {
      true: "ChoiceChips_chip_isSelected_true__1vjfhh57"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var chipText = _7a468({
  defaultClassName: "ChoiceChips_chipText__1vjfhh58",
  variantClassNames: {
    isSelected: {
      true: "ChoiceChips_chipText_isSelected_true__1vjfhh59"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var chipWrapper = _7a468({
  defaultClassName: "ChoiceChips_chipWrapper__1vjfhh53",
  variantClassNames: {
    align: {
      left: "ChoiceChips_chipWrapper_align_left__1vjfhh54",
      center: "ChoiceChips_chipWrapper_align_center__1vjfhh55"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var container = _7a468({
  defaultClassName: "ChoiceChips_container__1vjfhh50",
  variantClassNames: {
    align: {
      left: "ChoiceChips_container_align_left__1vjfhh51",
      center: "ChoiceChips_container_align_center__1vjfhh52"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var label = _7a468({
  defaultClassName: "ChoiceChips_label__1vjfhh5a",
  variantClassNames: {
    hidden: {
      true: "VisuallyHidden_visuallyHidden__1239gr90"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});